export default __webpack_public_path__ + "static/media/stylist_image_1.6e00cef1.png";